import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { getData } from "../../api";
import { getCaptchaUrl, PREV_IMG } from "../../constants/endPoints";

/**
 * A distorted-text image CAPTCHA (backend: Apis::getCaptcha — CodeIgniter's
 * own bundled captcha_helper, so no reCAPTCHA/hCaptcha site key had to be
 * obtained first) shared by Signup and Login.
 *
 * The backend's Captcha::verify() consumes the challenge the moment it's
 * checked, right or wrong, so a retry always needs a fresh image — callers
 * should call `refresh()` (via the ref) after any failed submit, not just
 * rely on this component refreshing itself.
 *
 * Exposes { captchaId, code, refresh() } via ref so the parent form can read
 * the current answer at submit time.
 */
const CaptchaField = forwardRef((props, ref) => {
    const [captchaId, setCaptchaId] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [code, setCode] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const refresh = async () => {
        setIsLoading(true);
        setCode("");
        const response = await getData(getCaptchaUrl());
        setIsLoading(false);
        if (response && response.data && response.data.response) {
            setCaptchaId(response.data.response.captcha_id);
            // The backend sends a path relative to uploads/ — same as every
            // other image in this app (ad/slide/product photos) — rather
            // than a full URL, since its own base_url() isn't reliable for
            // this route (see Apis::getCaptcha()'s comment).
            setImageUrl(PREV_IMG + response.data.response.image_path);
        }
    };

    useEffect(() => { refresh(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

    useImperativeHandle(ref, () => ({ captchaId, code, refresh }));

    return (
        <div className="form-outline mb-4">
            <label className="form-label mb-2" style={{ position: 'static', display: 'block' }}>
                Código de segurança
            </label>
            <div className="d-flex align-items-center mb-2" style={{ gap: 10 }}>
                {imageUrl
                    ? <img src={imageUrl} alt="Código de segurança" style={{ height: 46, borderRadius: 4 }} />
                    : <div style={{ height: 46, width: 160, background: '#eee', borderRadius: 4 }} />}
                <a
                    href="#"
                    onClick={(e) => { e.preventDefault(); if (!isLoading) refresh(); }}
                    title="Gerar novo código"
                    style={{ color: '#9d0000' }}
                >
                    <i className={"fa fa-refresh" + (isLoading ? " fa-spin" : "")}></i>
                </a>
            </div>
            <input
                type="text"
                className="form-control form-control-lg"
                placeholder="Digite o código da imagem"
                value={code}
                onChange={(e) => setCode(e.target.value)}
            />
        </div>
    );
});

export default CaptchaField;
